module.exports = __webpack_public_path__ + "static/media/sua-maquina-computer.8c7845c2.png";